import type { BistroSnapshot } from "../../shared/types";
import { mockBistroSnapshot } from "../mocks/bistro";
import { getWithFallback } from "./apiClient";

export interface BistroReportFilters { station?: string; category?: string; bistroCategory?: string; subCategory?: string; }

export function getBistroReport(filters: BistroReportFilters = {}, forceRefresh = false): Promise<BistroSnapshot> {
  const params = new URLSearchParams();
  if (filters.station) params.set("station", filters.station);
  if (filters.category) params.set("category", filters.category);
  if (filters.bistroCategory) params.set("bistroCategory", filters.bistroCategory);
  if (filters.subCategory) params.set("subCategory", filters.subCategory);
  if (forceRefresh) params.set("refresh", "1");
  const query = params.toString();
  return getWithFallback(`/reports/bistro${query ? `?${query}` : ""}`, () => ({ ...mockBistroSnapshot, filters: { ...mockBistroSnapshot.filters, selected: filters } }));
}
